import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import tripService from '../services/tripService';

const initialState = {
  trips: [],
  currentTrip: null,
  loading: false,
  error: null,
  totalPages: 1,
  currentPage: 1,
};

export const getTrips = createAsyncThunk(
  'trips/getTrips',
  async ({ search, page }, { rejectWithValue }) => {
    try {
      return await tripService.getTrips(search, page);
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const getTripById = createAsyncThunk(
  'trips/getTripById',
  async (id, { rejectWithValue }) => {
    try {
      return await tripService.getTripById(id);
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const createTrip = createAsyncThunk(
  'trips/createTrip',
  async (tripData, { rejectWithValue }) => {
    try {
      return await tripService.createTrip(tripData);
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const updateTrip = createAsyncThunk(
  'trips/updateTrip',
  async ({ id, tripData }, { rejectWithValue }) => {
    try {
      return await tripService.updateTrip(id, tripData);
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const deleteTrip = createAsyncThunk(
  'trips/deleteTrip',
  async (id, { rejectWithValue }) => {
    try {
      await tripService.deleteTrip(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const tripSlice = createSlice({
  name: 'trips',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.error = null;
    },
    updateCurrentTrip: (state, action) => {
      state.currentTrip = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTrips.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTrips.fulfilled, (state, action) => {
        state.loading = false;
        state.trips = action.payload.trips;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
      })
      .addCase(getTrips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTripById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTripById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentTrip = action.payload;
      })
      .addCase(getTripById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTrip.fulfilled, (state, action) => {
        state.trips.unshift(action.payload);
      })
      .addCase(updateTrip.fulfilled, (state, action) => {
        const index = state.trips.findIndex(trip => trip._id === action.payload._id);
        if (index !== -1) {
          state.trips[index] = action.payload;
        }
        if (state.currentTrip && state.currentTrip._id === action.payload._id) {
          state.currentTrip = action.payload;
        }
      })
      .addCase(deleteTrip.fulfilled, (state, action) => {
        state.trips = state.trips.filter(trip => trip._id !== action.payload);
      });
  },
});

export const { reset, updateCurrentTrip } = tripSlice.actions;
export default tripSlice.reducer;